import React from "react";

const Kotlin_Get_Started = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Get Started</h1>
      <p>Content for Kotlin Get Started goes here.</p>
    </div>
  );
};

export default Kotlin_Get_Started;
